import script from "./Step2DatosCombate.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2DatosCombate.vue?vue&type=script&setup=true&lang=js"

import "./Step2DatosCombate.vue?vue&type=style&index=0&id=4e984047&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e984047"]])

export default __exports__